import { render } from "./ScreenShare.vue?vue&type=template&id=1b89ed8c&scoped=true"
import script from "./ScreenShare.vue?vue&type=script&lang=js"
export * from "./ScreenShare.vue?vue&type=script&lang=js"

import "./ScreenShare.vue?vue&type=style&index=0&id=1b89ed8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b89ed8c"]])

export default __exports__